export { default } from "./NonExecutionButton.fragment";
